import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.5H5.625C4.589 1.5 3.75 2.34 3.75 3.375V20.625C3.75 21.66 4.59 22.5 5.625 22.5H18.375C19.41 22.5 20.25 21.66 20.25 20.625V12.75C20.25 11.7554 19.8549 10.8016 19.1517 10.0983C18.4484 9.39509 17.4946 9 16.5 9H14.625C14.1277 9 13.6508 8.80246 13.2992 8.45083C12.9475 8.09919 12.75 7.62228 12.75 7.125V5.25C12.75 4.25544 12.3549 3.30161 11.6517 2.59835C10.9484 1.89509 9.99456 1.5 9 1.5ZM15.61 12.436C15.67 12.3561 15.7134 12.2649 15.7377 12.1679C15.762 12.071 15.7666 11.9701 15.7514 11.8714C15.7361 11.7726 15.7012 11.6778 15.6489 11.5927C15.5965 11.5076 15.5276 11.4338 15.4463 11.3757C15.3649 11.3175 15.2728 11.2762 15.1753 11.2542C15.0778 11.2322 14.9769 11.2299 14.8785 11.2475C14.7801 11.265 14.6862 11.3021 14.6023 11.3564C14.5184 11.4108 14.4462 11.4813 14.39 11.564L11.154 16.094L9.53 14.47C9.38782 14.3375 9.19978 14.2654 9.00548 14.2688C8.81118 14.2723 8.62579 14.351 8.48838 14.4884C8.35097 14.6258 8.27225 14.8112 8.26882 15.0055C8.2654 15.1998 8.33752 15.3878 8.47 15.53L10.72 17.78C10.797 17.8569 10.8898 17.9162 10.992 17.9536C11.0942 17.9911 11.2033 18.0059 11.3118 17.9969C11.4202 17.988 11.5255 17.9555 11.6201 17.9019C11.7148 17.8482 11.7967 17.7745 11.86 17.686L15.61 12.436Z"
        fill={colorValue}
      />
      <path
        d="M12.971 1.816C13.7975 2.76896 14.2518 3.98855 14.25 5.25V7.125C14.25 7.332 14.418 7.5 14.625 7.5H16.5C17.7615 7.49825 18.981 7.95248 19.934 8.779C19.494 7.10571 18.6175 5.5793 17.3941 4.35589C16.1707 3.13248 14.6443 2.25596 12.971 1.816Z"
        fill={colorValue}
      />
    </svg>
  );
};
